var _rect, _rect2, _path, _path2, _path3, _line, _path4, _line2, _path5, _path6, _path7, _path8, _path9, _rect3, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _rect4, _rect5, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _rect6, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInAndOutHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 250,
    viewBox: "0 0 173 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.8938,
    y: 19.9875,
    width: 27.4366,
    height: 91.9843,
    rx: 4.7,
    fill: "white",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.2781,
    y: 21.4852,
    width: 24.6642,
    height: 88.9509,
    rx: 3.8,
    fill: "white",
    stroke: "#C6C3C3",
    strokeWidth: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.6301 61.9785H58.4666C57.1928 61.9785 56.1602 63.002 56.1602 64.2645C56.1602 65.5271 57.1928 66.5506 58.4666 66.5506H62.6301",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.113 112.272V25.2467C138.113 22.1764 135.699 19.6875 132.722 19.6875H119.782V24.1349C119.782 25.977 118.333 27.4704 116.547 27.4704H98.2152C96.4286 27.4704 94.9802 25.977 94.9802 24.1349V19.6875H80.962C77.9842 19.6875 75.5703 22.1764 75.5703 25.2467V112.272H138.113Z",
    fill: "#F3F3F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8303 230.315H80.962C77.9842 230.315 75.5703 227.71 75.5703 224.497V25.5059C75.5703 22.2925 77.9842 19.6875 80.962 19.6875H94.9802V24.3423C94.9802 26.2703 96.4286 27.8333 98.2152 27.8333H116.547C118.333 27.8333 119.782 26.2703 119.782 24.3423V19.6875H132.722C135.699 19.6875 138.113 22.2925 138.113 25.5059V224.497C138.113 227.71 135.699 230.315 132.722 230.315H118.675",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 75.8594,
    y1: 119.233,
    x2: 81.251,
    y2: 119.233,
    stroke: "#444444",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.875 119.211L101.739 119.211",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.3,
    x2: 5.39165,
    y2: -0.3,
    transform: "matrix(-1 0 0 1 138.402 119.533)",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9297 119.533L80.9297 114.344L88.5845 114.344",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.875 119.533L111.875 114.344L119.53 114.344",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.062 119.533L102.062 114.344L94.4558 114.344",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.012 119.533L133.012 114.344L125.405 114.344",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8281 230.315V227.02H118.855V230.315",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80.8273,
    y: 125.06,
    width: 21.9013,
    height: 88.6795,
    rx: 1.7,
    fill: "#F8F8F8",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 83.0156,
    y1: 115.712,
    x2: 100.54,
    y2: 115.712,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 83.9375,
    y1: 118.323,
    x2: 99.6174,
    y2: 118.323,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 100.239,
    y1: 222.427,
    x2: 83.3144,
    y2: 222.427,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 99.3172,
    y1: 220.075,
    x2: 84.2373,
    y2: 220.075,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 98.3953,
    y1: 217.726,
    x2: 85.1601,
    y2: 217.726,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 97.4734,
    y1: 215.374,
    x2: 86.0829,
    y2: 215.374,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 85.7813,
    y1: 120.942,
    x2: 97.7718,
    y2: 120.942,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 87.9844,
    y: 122.434,
    width: 7.58498,
    height: 2.64962,
    fill: "#F8F8F8",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 133.309,
    y: 214.157,
    width: 21.9013,
    height: 88.6795,
    rx: 1.7,
    transform: "rotate(-180 133.309 214.157)",
    fill: "#F8F8F8",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 130.821,
    y1: 223.505,
    x2: 113.896,
    y2: 223.505,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 129.899,
    y1: 220.894,
    x2: 114.819,
    y2: 220.894,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 113.598,
    y1: 116.79,
    x2: 131.122,
    y2: 116.79,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 114.52,
    y1: 119.141,
    x2: 130.199,
    y2: 119.141,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 115.441,
    y1: 121.491,
    x2: 129.277,
    y2: 121.491,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 116.363,
    y1: 123.843,
    x2: 128.354,
    y2: 123.843,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 128.055,
    y1: 218.275,
    x2: 116.665,
    y2: 218.275,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 126.152,
    y: 216.783,
    width: 7.58498,
    height: 2.64962,
    transform: "rotate(-180 126.152 216.783)",
    fill: "#F8F8F8",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6914 225.057H133.847",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7812 147.758V185.611",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.258 158.816L107.258 178.35",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M103.117 158.816H111.4",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M103.117 168.584H111.4",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M123.785 154.18L118.855 152.48L118.855 151.453L124.543 153.594L124.543 154.25L123.785 154.18ZM118.855 155.602L123.785 153.898L124.543 153.824L124.543 154.484L118.855 156.633L118.855 155.602ZM120.965 155.52L120.187 155.52L120.187 152.426L120.965 152.426L120.965 155.52ZM123.785 159.484L118.855 157.785L118.855 156.758L124.543 158.898L124.543 159.555L123.785 159.484ZM118.855 160.906L123.785 159.203L124.543 159.129L124.543 159.789L118.855 161.937L118.855 160.906ZM120.965 160.824L120.187 160.824L120.187 157.73L120.965 157.73L120.965 160.824ZM123.785 164.789L118.855 163.09L118.855 162.062L124.543 164.203L124.543 164.859L123.785 164.789ZM118.855 166.211L123.785 164.508L124.543 164.434L124.543 165.094L118.855 167.242L118.855 166.211ZM120.965 166.129L120.187 166.129L120.187 163.035L120.965 163.035L120.965 166.129ZM124.562 172.293L118.855 172.293L118.855 171.352L123.445 171.352L122.973 169.957L123.75 169.957L124.562 172.18L124.562 172.293ZM119.324 174.363C119.47 174.363 119.592 174.413 119.691 174.512C119.793 174.611 119.844 174.745 119.844 174.914C119.844 175.086 119.793 175.22 119.691 175.316C119.592 175.415 119.47 175.465 119.324 175.465C119.178 175.465 119.056 175.415 118.957 175.316C118.858 175.22 118.809 175.086 118.809 174.914C118.809 174.745 118.858 174.611 118.957 174.512C119.056 174.413 119.178 174.363 119.324 174.363ZM121.5 177.484L121.684 176.734L124.543 177.043L124.543 180.109L123.746 180.109L123.746 177.824L122.352 177.668C122.404 177.757 122.454 177.879 122.504 178.035C122.556 178.191 122.582 178.37 122.582 178.57C122.582 178.839 122.538 179.078 122.449 179.289C122.363 179.503 122.237 179.684 122.07 179.832C121.906 179.98 121.706 180.094 121.469 180.172C121.234 180.25 120.97 180.289 120.676 180.289C120.413 180.289 120.167 180.25 119.937 180.172C119.708 180.096 119.507 179.982 119.332 179.828C119.158 179.674 119.021 179.48 118.922 179.246C118.826 179.014 118.777 178.74 118.777 178.422C118.777 178.185 118.811 177.957 118.879 177.738C118.949 177.522 119.052 177.328 119.187 177.156C119.326 176.984 119.495 176.846 119.695 176.742C119.898 176.638 120.132 176.578 120.395 176.562L120.395 177.484C120.21 177.508 120.052 177.559 119.922 177.637C119.794 177.717 119.697 177.824 119.629 177.957C119.561 178.09 119.527 178.243 119.527 178.418C119.527 178.577 119.555 178.714 119.609 178.828C119.667 178.943 119.747 179.038 119.852 179.113C119.958 179.191 120.083 179.249 120.227 179.285C120.37 179.324 120.529 179.344 120.703 179.344C120.87 179.344 121.022 179.322 121.16 179.277C121.298 179.236 121.418 179.172 121.52 179.086C121.621 179.003 121.699 178.897 121.754 178.77C121.811 178.642 121.84 178.495 121.84 178.328C121.84 178.104 121.807 177.932 121.742 177.812C121.677 177.695 121.596 177.586 121.5 177.484ZM119.895 183.141L124.543 184.637L124.543 185.719L118.855 183.68L118.855 182.949L119.895 183.141ZM124.543 181.758L119.895 183.242L118.855 183.445L118.855 182.711L124.543 180.68L124.543 181.758Z",
    fill: "#DADADA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5117 154.18L88.582 152.48L88.582 151.453L94.2695 153.594L94.2695 154.25L93.5117 154.18ZM88.582 155.602L93.5117 153.898L94.2695 153.824L94.2695 154.484L88.582 156.633L88.582 155.602ZM90.6914 155.52L89.9141 155.52L89.9141 152.426L90.6914 152.426L90.6914 155.52ZM93.5117 159.484L88.582 157.785L88.582 156.758L94.2695 158.898L94.2695 159.555L93.5117 159.484ZM88.582 160.906L93.5117 159.203L94.2695 159.129L94.2695 159.789L88.582 161.937L88.582 160.906ZM90.6914 160.824L89.9141 160.824L89.9141 157.73L90.6914 157.73L90.6914 160.824ZM93.5117 164.789L88.582 163.09L88.582 162.062L94.2695 164.203L94.2695 164.859L93.5117 164.789ZM88.582 166.211L93.5117 164.508L94.2695 164.434L94.2695 165.094L88.582 167.242L88.582 166.211ZM90.6914 166.129L89.9141 166.129L89.9141 163.035L90.6914 163.035L90.6914 166.129ZM94.2891 172.293L88.582 172.293L88.582 171.352L93.1719 171.352L92.6992 169.957L93.4766 169.957L94.2891 172.18L94.2891 172.293ZM89.0508 174.363C89.1966 174.363 89.319 174.413 89.418 174.512C89.5195 174.611 89.5703 174.745 89.5703 174.914C89.5703 175.086 89.5195 175.22 89.418 175.316C89.319 175.415 89.1966 175.465 89.0508 175.465C88.9049 175.465 88.7826 175.415 88.6836 175.316C88.5846 175.22 88.5352 175.086 88.5352 174.914C88.5352 174.745 88.5846 174.611 88.6836 174.512C88.7826 174.413 88.9049 174.363 89.0508 174.363ZM91.2266 177.484L91.4102 176.734L94.2695 177.043L94.2695 180.109L93.4727 180.109L93.4727 177.824L92.0781 177.668C92.1302 177.757 92.181 177.879 92.2305 178.035C92.2826 178.191 92.3086 178.37 92.3086 178.57C92.3086 178.839 92.2643 179.078 92.1758 179.289C92.0898 179.503 91.9635 179.684 91.7969 179.832C91.6328 179.98 91.4323 180.094 91.1953 180.172C90.9609 180.25 90.6966 180.289 90.4023 180.289C90.1393 180.289 89.8932 180.25 89.6641 180.172C89.4349 180.096 89.2331 179.982 89.0586 179.828C88.8841 179.674 88.7474 179.48 88.6484 179.246C88.5521 179.014 88.5039 178.74 88.5039 178.422C88.5039 178.185 88.5378 177.957 88.6055 177.738C88.6758 177.522 88.7786 177.328 88.9141 177.156C89.0521 176.984 89.2214 176.846 89.4219 176.742C89.625 176.638 89.8581 176.578 90.1211 176.562L90.1211 177.484C89.9362 177.508 89.7786 177.559 89.6484 177.637C89.5208 177.717 89.4232 177.824 89.3555 177.957C89.2878 178.09 89.2539 178.243 89.2539 178.418C89.2539 178.577 89.2812 178.714 89.3359 178.828C89.3932 178.943 89.474 179.038 89.5781 179.113C89.6849 179.191 89.8099 179.249 89.9531 179.285C90.0964 179.324 90.2552 179.344 90.4297 179.344C90.5964 179.344 90.7487 179.322 90.8867 179.277C91.0247 179.236 91.1445 179.172 91.2461 179.086C91.3477 179.003 91.4258 178.897 91.4805 178.77C91.5378 178.642 91.5664 178.495 91.5664 178.328C91.5664 178.104 91.5339 177.932 91.4687 177.812C91.4036 177.695 91.3229 177.586 91.2266 177.484ZM89.6211 183.141L94.2695 184.637L94.2695 185.719L88.582 183.68L88.582 182.949L89.6211 183.141ZM94.2695 181.758L89.6211 183.242L88.582 183.445L88.582 182.711L94.2695 180.68L94.2695 181.758Z",
    fill: "#DADADA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.117 178.35H111.4",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInAndOutHelp);
export default __webpack_public_path__ + "static/media/in-and-out-help.2176c6358fcf24d1994f5146f99b6c35.svg";
export { ForwardRef as ReactComponent };